/*******************************************************************************
UPDATE FILTER COUNTS
Count the number of items that each filter tab matches (if that feature is turned on).
*******************************************************************************/

import checkForMatch from './check-for-match';
import getAllTabs from './get-all-tabs';
import getFilterSettings from './get-filter-settings';
import getTabSettings from './get-tab-settings';

export default function updateFilterCounts() {
    const $tabSets = $('.filter-tabs');

    // If there are no tabs on screen, exit out
    if ($tabSets.length === 0) { return; }

    // Loop through all the sets of tabs
    $tabSets.each((index, tabSet) => {
        const $tabs = $(tabSet);
        const tabSetName = $tabs.data('name') || '';

        // Get an array of tab objects to loop through
        const allTabs = getAllTabs(tabSetName);

        // Get the settings for the filter
        const filterSettings = getFilterSettings(tabSetName);

        // Get the all items to filter on
        const $items = $(filterSettings.items);

        // Loop through all the tabs
        $.each(allTabs, (tabIndex, tab) => {

            // If the counter feature is turned on
            if (tab.showCount) {
                let counter = 0;

                // Gather all the settings related to the current filter
                const tabSettings = getTabSettings(tab.name);

                // Check each item to see if it matches the filter tab criteria
                $items.each((i, item) => {
                    const $item = $(item);

                    // Check to see if the current item matches the filter
                    const filterMatches = checkForMatch($item, filterSettings, tabSettings);

                    // Increment the match counter
                    if (filterMatches) { counter += 1; }
                });

                // Get the counter element (which may not exist) for current tab element
                const $tabCounter = tab.$element.find('.filter-tab-count');

                // If the counter element is already there, then update the counter
                if ($tabCounter.length) {
                    $tabCounter.text(counter);
                }
                // Otherwise add the counter to the page
                else {
                    tab.$element.append(`<span class="filter-tab-count">${counter}</span>`);
                }
            }
        });
    });

}
